module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Thin-c35e0f08880677edbd25e58660451b8d.woff";